var moment = require('moment')
var dateutils = require('./dateutils')
exports.getCollectionQuery = function getCollectionQuery (context, payload, queryParameters) {
  // if is next page, we can re-use the lastTaxInvoiceShown
  // if is previous page, we use the opposite sorting, and re-use the firstTaxInvoiceShown
  // if jump to last page, we use opposite sorting, and re-calculate the limit from total rows
  console.log('currentPage: ' + context.state.currentPage)
  if (context.state.currentPage === 1) {
    console.log('Show first page')
    return context.rootState.firestoreDB.collection(queryParameters.collectionName)
      .orderBy(queryParameters.orderByField, queryParameters.orderByDirection)
      .limit(context.state.rowsPerPage)
  } else if (context.state.currentPage === Math.ceil(context.state.totalRows / context.state.rowsPerPage)) {
    console.log('Show last page')
    let limit = context.state.totalRows % context.state.rowsPerPage
    if (limit === 0) {
      limit = context.state.rowsPerPage
    }
    queryParameters.flippedSorting = true
    return context.rootState.firestoreDB.collection(queryParameters.collectionName)
      .orderBy(queryParameters.orderByField, queryParameters.orderByFlippedDirection)
      .limit(limit)
  } else if (context.state.currentPage - context.state.lastShown.lastShownPage === 1) {
    console.log('Show next page')
    return context.rootState.firestoreDB.collection(queryParameters.collectionName)
      .orderBy(queryParameters.orderByField, queryParameters.orderByDirection)
      .startAfter(context.state.lastShown.lastRowShown)
      .limit(context.state.rowsPerPage)
  } else if (context.state.currentPage - context.state.lastShown.lastShownPage === -1) {
    console.log('Show previous page')
    queryParameters.flippedSorting = true
    return context.rootState.firestoreDB.collection(queryParameters.collectionName)
      .orderBy(queryParameters.orderByField, queryParameters.orderByFlippedDirection)
      .startAfter(context.state.lastShown.firstRowShown)
      .limit(context.state.rowsPerPage)
  } else if (context.state.currentPage > 1 && context.state.currentPage === context.state.lastShown.lastShownPage) {
    console.log('Re-Show not first page')
    return context.rootState.firestoreDB.collection(queryParameters.collectionName)
      .orderBy(payload.orderBys, 'desc')
      .startAt(context.state.lastShown.firstRowShown)
      .limit(context.state.rowsPerPage)
  } else {
    if (context.state.currentPage > context.state.lastShown.lastShownPage) {
      console.log('Jumped forward page')
      let limit = (context.state.currentPage - context.state.lastShown.lastShownPage) * context.state.rowsPerPage
      queryParameters.jumpedPage = true
      queryParameters.jumpedLimit = limit
      return context.rootState.firestoreDB.collection(queryParameters.collectionName)
        .orderBy(queryParameters.orderByField, queryParameters.orderByDirection)
        .startAfter(context.state.lastShown.lastRowShown)
        .limit(limit)
    } else if (context.state.currentPage < context.state.lastShown.lastShownPage) {
      console.log('Jumped backward page')
      let limit = (context.state.lastShown.lastShownPage - context.state.currentPage) * context.state.rowsPerPage
      queryParameters.jumpedPage = true
      queryParameters.jumpedLimit = limit
      queryParameters.flippedSorting = true
      return context.rootState.firestoreDB.collection(queryParameters.collectionName)
        .orderBy(queryParameters.orderByField, queryParameters.orderByFlippedDirection)
        .startAfter(context.state.lastShown.firstRowShown)
        .limit(limit)
    } else {
      console.error('Unsupported page navigation')
      context.commit('toggleDisabledPagination', false)
      return null
    }
  }
}
exports.queryCollection = function queryCollection (docQuery, context, queryParameters, hasShowDetail) {
  docQuery.get().then(function (querySnapshot) {
    let index = 0
    let jumpIndex = 0
    querySnapshot.forEach(function (doc) {
      if (queryParameters.jumpedPage && jumpIndex < (queryParameters.jumpedLimit - context.state.rowsPerPage)) {
        jumpIndex++
        return
      }
      if (index === 0) {
        context.state.lastShown.firstRowShown = doc
      }
      index++
      // console.log(subDoc.id + '=>' + subDoc.data())
      let documentData = doc.data()
      let rowObject = {}
      for (let eachProp in documentData) {
        let propName = eachProp
        // console.log('eachProp: ' + eachProp)
        if (propName === 'orderDate' && doc.data()[eachProp]) {
          let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
          rowObject[propName] = m.format('DD/MMM/YYYY')
        } else if (propName === 'createdDate' && doc.data()[eachProp]) {
          let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
          rowObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
        } else if (propName === 'updatedDate' && doc.data()[eachProp]) {
          let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
          rowObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
        } else if (propName === 'uploadedDate' && doc.data()[eachProp]) {
          let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
          rowObject[propName] = m.format('DD/MM/YYYY HH:mm:ss')
        } else {
          rowObject[propName] = doc.data()[eachProp]
        }
      }
      if (hasShowDetail) {
        rowObject['_showDetails'] = false
      }
      rowObject.docId = doc.id
      rowObject._rowVariant = ''
      if (queryParameters.flippedSorting === true) {
        queryParameters.flippedResult.push(rowObject)
      } else {
        context.state.all.push(rowObject)
      }
      context.state.lastShown.lastShownPage = context.state.currentPage
      context.state.lastShown.lastRowShown = doc
    })
    if (queryParameters.flippedSorting === true) {
      queryParameters.flippedResult.reverse()
      queryParameters.flippedResult.forEach(function (value) {
        context.state.all.push(value)
      })
      let tempHolder = context.state.lastShown.firstRowShown
      context.state.lastShown.firstRowShown = context.state.lastShown.lastRowShown
      context.state.lastShown.lastRowShown = tempHolder
    }
    context.commit('toggleShowLoadingAnimation', false)
    if (context.state.all.length === 0) {
      context.commit('toggleShowNoResult', true)
    }
    context.commit('toggleDisabledPagination', false)
  }).catch(function (err) {
    context.commit('toggleDisabledPagination', false)
    console.log('Error while fetching documents in invoice collection: ' + err)
    context.commit('toggleShowLoadingAnimation', false)

    context.commit('toggleshowLoadingError', true)
    context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]')
  })
}



// WEBPACK FOOTER //
// ./src/store/firestoretable.js